import React, { useCallback, useMemo } from 'react';
import { Field, HeaderSection, Text, Select } from '@groupelacentrale/contact-storybook';
import { VehicleDescription, WarrantyDesignation } from 'types';
import { FormikErrors, FormikTouched } from 'formik';

interface Props {
  title: string;
  values: VehicleDescription;
  labelos: WarrantyDesignation[];
  errors: FormikErrors<VehicleDescription>;
  touched: FormikTouched<VehicleDescription>;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
}

export const VehicleDescriptionFormViewSectionWarranty: React.FC<Props> = ({
  title,
  labelos,
  values: { duration, designation },
  touched,
  errors,
  setFieldValue,
}) => {
  // Valid pattern [0-9]* : only numbers
  const handleDurationChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      e.currentTarget.value = (e.currentTarget.validity.valid ? e.currentTarget.value : duration ?? '').toString();
      const value = Number(e.currentTarget.value);
      if (value <= 240) {
        setFieldValue('duration', Number(e.currentTarget.value));
      }
    },
    [duration, setFieldValue],
  );

  const handleDesignationChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      setFieldValue(
        'designation',
        labelos.find(l => l.id === e.currentTarget.value),
      );
    },
    [labelos, setFieldValue],
  );

  const labelosSelectList = useMemo(
    () =>
      labelos && [
        { label: 'Choisissez', value: '' },
        ...labelos.map(labelo => ({
          value: labelo.id,
          label: labelo.label,
        })),
      ],
    [labelos],
  );

  return (
    <div className="vehicle-description-section">
      <HeaderSection noUnderline>{title}</HeaderSection>
      <Field
        type="text"
        pattern="[0-9]*"
        name="duration"
        label="Garantie"
        value={duration ?? ''}
        unit="mois"
        onChange={handleDurationChange}
        errorMessage={touched.duration ? errors.duration : undefined}
      />
      {labelos && labelos.length > 0 && (
        <div className="field-wrapper">
          <Text className="field-label">Label</Text>
          <Select
            name="designation"
            defaultValue={designation ? designation.id : ''}
            options={labelosSelectList}
            onChange={handleDesignationChange}
            errorMessage={touched.designation ? errors.designation : undefined}
          />
        </div>
      )}
    </div>
  );
};
